import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripNewLine',
  standalone: true,
})
export class StripNewLinePipe implements PipeTransform {
  public transform(value: string): string {
    return value.replace(/\\n/g, '');
  }
}
